<!-- Dialog di errore duplicato nome work order -->
<h1 mat-dialog-title>{{ 'duplicateNameTitle' | translate }}</h1>

<div mat-dialog-content>
  <!-- Messaggio di errore con icona -->
  <div class="error-message">
    <mat-icon color="warn">error</mat-icon>
    <div class="error-text">
      <span class="error-main">{{ 'duplicateNameMessage' | translate }}</span>
    </div>
  </div>
  
  <!-- Nome duplicato evidenziato -->
  <div class="duplicate-info">
    <strong>{{ 'duplicateNameLabel' | translate }}:</strong>
    <span class="duplicate-name-value">{{ duplicateName }}</span>
  </div>

  <!-- Messaggio dettagliato -->
  <p class="detail-message">
    {{ 'duplicateNameDetail' | translate }}
  </p>
</div>

<!-- Pulsante di chiusura -->
<div mat-dialog-actions>
  <ct-button [configuration]="closeButton"></ct-button>
</div>
